import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

const Repeater = ({ text, onClick }) => {
  return (
    <div className="repeater">
      <a
        href="/#"
        onClick={e => {
          onClick(e)
        }}
        className="repeater_add"
      >
        <div className="repeater_add_icon" />
        <div className="repeater_add_label">{text}</div>
      </a>
    </div>
  )
}

Repeater.propTypes = {
  text: propTypes.string.isRequired,
  onClick: propTypes.func.isRequired
}

export default Repeater
